import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { LocalStorageService } from 'ngx-webstorage';
import { Observable } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';
import { AuthService } from 'src/app/auth/auth.service';
import { OptionService } from 'src/app/options/option.service';
import { PermissionService } from 'src/app/systemsettings/permissions/permission.service';
import { menuPerm } from '../menuPerm.model';
import { DirectChargeService } from 'src/app/options/direct-charge-orders/direct-charge.service';


@Component({
  selector: 'app-main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.css']
})
export class MainComponent implements OnInit {

  userFullName: string = "";
  role: string = "";
  roleId!: string;
  userId!: string;
  menuPerm: menuPerm[] = [];
  notSeenMessageCount = 0;
  notSeenDirectChargeCount = 0;
  isHandset$: Observable<boolean> = this.breakpointObserver.observe(Breakpoints.Handset)
    .pipe(
      map(result => result.matches),
      shareReplay()
    );

  direction!: any;
  constructor(private breakpointObserver: BreakpointObserver,
    private localStorage: LocalStorageService,
    private authService: AuthService,
    private permissionService: PermissionService,
    private optionService: OptionService,
    private direcChargeService: DirectChargeService,
    private translate: TranslateService) { }

  ngOnInit(): void {

    this.userFullName = this.localStorage.retrieve("userInfo").fullName;
    this.role = this.localStorage.retrieve("userInfo").role;
    this.roleId = this.localStorage.retrieve("userInfo").roleId;
    this.userId = this.localStorage.retrieve("userInfo").userId;
    this.selectChange();
    this.getMenu();
    this.getNotSeenMessageCount();
    this.getNotSeenDirectChargeCount();
    setInterval(() =>

      this.getNotSeenMessageCount(),

      30000);

    setInterval(() =>

      this.getNotSeenDirectChargeCount(),

      30000);
  }

  getNotSeenMessageCount() {
    this.optionService.getNotSeenMessageCount().subscribe(data => {
      this.notSeenMessageCount = data;
    }, error => {
      console.log(error);
    })
  }

  getNotSeenDirectChargeCount() {
    this.direcChargeService.getNotSeenCount().subscribe(data => {
      this.notSeenDirectChargeCount = data;
    }, error => {
      console.log(error);
    })
  }

  onClickMessages() {
    this.updateMessagesSeen();
  }

  updateMessagesSeen() {
    this.optionService.updateNotSeenMessage().subscribe(data => {
      this.getNotSeenMessageCount();
    },
      error =>
        console.log(error))
  }

  updateDirectChargeSeen() {
    this.direcChargeService.updateNotSeen().subscribe(data => {
      this.getNotSeenDirectChargeCount();
    },
      error =>
        console.log(error))
  }

  onClickDirectCharge() {
    this.updateDirectChargeSeen();
  }

  selectChange() {
    var body = document.getElementsByTagName('body')[0];
    var html = document.getElementsByTagName('html')[0];
    body.removeAttribute("dir");
    html.removeAttribute("dir");
    this.localStorage.retrieve("lang") == 0 ? this.direction = "ltr" : this.direction = "rtl";
    this.localStorage.retrieve("lang") == 0 ? this.translate.use('en') : this.translate.use('ar');

    if (this.localStorage.retrieve("lang") == 0) {

      body.setAttribute("dir", "ltr");
      html.setAttribute("dir", "ltr");
    }
    else {
      body.setAttribute("dir", "rtl");
      html.setAttribute("dir", "rtl");
    }

  }

  logout() {
    this.authService.logout();
  }

  getMenu() {
    this.permissionService.getMenu(this.userId).subscribe(data => {
      this.menuPerm = data;
    }, error => {
      console.log(error);
    })
  }

}

